const migrationsV5 = require('./reporters/migrations-V5/reporter');

module.exports = {
  migrationsV5: migrationsV5,
};



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-reporters/index.js
// module id = 2779
// module chunks = 0 1